var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMobileB(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.586,
    height: 21.586,
    viewBox: "0 0 21.586 21.586",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "vuesax/outline/mobile"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.568 19.337h-5.4C1.205 19.337 0 18.132 0 14.166V5.172C0 1.205 1.205 0 5.172 0h5.4c3.966 0 5.172 1.205 5.172 5.172v8.994c-.004 3.966-1.209 5.171-5.176 5.171zM5.172 1.349c-3.22 0-3.823.612-3.823 3.823v8.994c0 3.211.6 3.823 3.823 3.823h5.4c3.22 0 3.823-.612 3.823-3.823V5.172c0-3.211-.6-3.823-3.823-3.823z",
    transform: "translate(2.923 1.124)",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Vector",
    d: "M4.272 1.349H.675A.679.679 0 0 1 0 .675.679.679 0 0 1 .675 0h3.6a.679.679 0 0 1 .675.675.679.679 0 0 1-.678.674z",
    transform: "translate(8.32 4.272)",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Vector",
    d: "M2.069 4.137a2.069 2.069 0 1 1 2.068-2.068 2.069 2.069 0 0 1-2.068 2.068zm0-2.8a.72.72 0 1 0 .72.72.722.722 0 0 0-.72-.717z",
    transform: "translate(8.724 13.725)",
    style: {
      fill: "gray"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileB);
export default __webpack_public_path__ + "static/media/mobile_b.4ef04c397e89652eec5a79ce786f0285.svg";
export { ForwardRef as ReactComponent };